// @flow
import { makeStyles } from "@material-ui/styles";
export default makeStyles(() => ({
  pollContainer: {
    display: "flex",
    flexDirection: "column"
  }
}), { index: 1 })